module.exports = __webpack_public_path__ + "assets/eway-payments.e6dae657.svg";